import sharedOrder from '#frontend/singleDataLayer/shared/order.js';

/**
 * System order (purchase)
 * @param {object} cart
 * @returns {object}
 */
export default (cart) => ({
	system: sharedOrder(cart),
	event: 'system.order'
});
